<template>
  <div>
    <v-toolbar dark class="primary">
      <v-toolbar-title class="white--text">Zwerverhunt</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$router.push('/')">
        <v-icon class="white--text">map</v-icon>
      </v-btn>
      <v-btn icon @click="$router.push('/settings')">
        <v-icon class="white--text">settings</v-icon>
      </v-btn>
      <v-btn icon v-if="user.role == 99" @click="$router.push('/foxes')">
        <v-icon class="white--text">pets</v-icon>
      </v-btn>
      <v-btn icon v-if="user.role == 99" @click="$router.push('/pois')">
        <v-icon class="white--text">local_activity</v-icon>
      </v-btn>
      <v-btn icon v-if="user.role == 99" @click="$router.push('/users')">
        <v-icon class="white--text">group</v-icon>
      </v-btn>
    </v-toolbar>

    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  computed: {
    user () {
      return this.$store.getters.user;
    }
  },
  methods: {
    logout ()  {
        this.$store.dispatch('logout').then(() => {
          this.$router.push('/login');
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/App.vue